// styles
import './Header.scss';

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-logo-letters">B</div>
      <div className="header-logo-letters">B</div>
      <div className="header-logo-letters">C</div>
      <div className="header-logo-title"> Learning English Drama</div>
    </div>
  );
};

export default Header;
